(function () {
  'use strict';

  // This script tag is emitted once per card; the browser fetches the asset once
  // but executes each tag. First run installs everything, later runs just rescan.
  if (window.__ccSwatches) { window.__ccSwatches.scan(); return; }

  var SHOW_MAX = 6;

  // Ordered keyword -> hex pairs: more specific names FIRST so e.g.
  // "Optical White" resolves before the plain "white" entry matches.
  var COLOR_MAP = [
    ['optical white', '#f8f8f0'],
    ['egret', '#f0ece0'], ['cream', '#fffdd0'], ['chalk', '#f5f5f0'],
    ['natural', '#e8dfc8'], ['ivory', '#f6f1e1'],
    ['navy', '#001f5b'], ['marine', '#001f5b'],
    ['burgundy', '#6d1a2c'], ['bordeaux', '#5c1e2e'],
    ['chocolate', '#4e2f1e'], ['brown', '#795548'], ['tan', '#d2b48c'],
    ['beige', '#f5f0e8'], ['khaki', '#8a7d54'], ['olive', '#5c5c3d'],
    ['pavemint', '#b7cbb1'], ['mint', '#98c9a3'], ['teal', '#00897b'],
    ['thyme', '#4a5e3a'],
    ['coral', '#ef5350'], ['pink', '#f48fb1'], ['purple', '#7b1fa2'],
    ['lavender', '#c5a3d6'],
    ['yellow', '#ffd600'], ['gold', '#c9a227'], ['orange', '#ef6c00'],
    ['red', '#cc1111'], ['rouge', '#cc1111'],
    ['blue', '#1a53ff'], ['bleu', '#1a53ff'],
    ['green', '#2d6a4f'], ['vert', '#2d6a4f'],
    ['grey', '#9e9e9e'], ['gray', '#9e9e9e'], ['silver', '#c0c0c0'],
    ['white', '#ffffff'], ['blanc', '#ffffff'],
    ['black', '#111111'], ['noir', '#111111']
  ];

  function colorFromName(name) {
    var lc = (name || '').toLowerCase();
    if (!lc) return null;
    for (var i = 0; i < COLOR_MAP.length; i++) {
      if (lc.indexOf(COLOR_MAP[i][0]) !== -1) return COLOR_MAP[i][1];
    }
    return null;
  }

  function resolveColor(p) {
    if (p.swatch_color) return p.swatch_color;
    return colorFromName(p.base_colour) || colorFromName(p.title) || '#cccccc';
  }

  // Same ordering rules as the PDP swatches (snippets/color-swatches.liquid):
  // YOrder_[N] tags ascending first, untagged after them alphabetically.
  function parseYOrder(tags) {
    if (!tags) return null;
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('YOrder_') === 0) {
        var n = parseInt(tags[i].slice(7), 10);
        if (!isNaN(n)) return n;
      }
    }
    return null;
  }

  function bySwatchOrder(a, b) {
    var ao = parseYOrder(a.tags), bo = parseYOrder(b.tags);
    if (ao !== null && bo !== null) {
      if (ao !== bo) return ao - bo;
      return a.title.localeCompare(b.title);
    }
    if (ao !== null) return -1;
    if (bo !== null) return 1;
    return a.title.localeCompare(b.title);
  }

  // Styling replicated from the original converse.ca collection cards
  // (converse.css .color-swatch--sm overrides + theme.css .color-swatch__view-more):
  // 14px circles on mobile / 20px on desktop, 1px rgba(0,0,0,.5) border, no hover
  // halo, selected = inset white-on-dark "bullseye" ring and grows to 20px,
  // "+N" overflow as a small bordered pill.
  // 9.24: "+N" pill is now a link to the currently selected colorway's PDP,
  // where every colour in the family is shown.
  var CSS =
    '.cc-swatches{margin-top:6px;min-height:20px}' +
    '.cc-swatches__row{display:flex;align-items:center;flex-wrap:wrap;gap:3px}' +
    '.cc-dot{display:block;width:14px;height:14px;padding:0;border-radius:50%;' +
      'border:1px solid rgba(0,0,0,.5);flex-shrink:0;cursor:pointer;' +
      'appearance:none;-webkit-appearance:none;' +
      'background-position:center;background-size:cover;' +
      'transition:box-shadow .2s ease-in-out,width .2s ease-in-out,height .2s ease-in-out}' +
    '.cc-dot--active{width:20px;height:20px;' +
      'box-shadow:inset 0 0 0 .2em #fff,inset 0 0 0 .25em rgba(0,0,0,.6)}' +
    '@media screen and (min-width:1000px){' +
      '.cc-swatches__row{gap:9px}' +
      '.cc-dot{width:20px;height:20px}' +
    '}' +
    '.cc-more-count{font-size:.625rem;color:inherit;opacity:.7;white-space:nowrap;' +
      'border:1px solid rgba(0,0,0,.15);border-radius:9999px;padding:1px 8px;' +
      'margin-inline-start:6px;text-decoration:none;cursor:pointer;' +
      'transition:opacity .2s ease-in-out,border-color .2s ease-in-out}' +
    'a.cc-more-count:hover,a.cc-more-count:focus-visible{opacity:1;border-color:rgba(0,0,0,.5)}';

  var cache = {}, pending = {};

  function fetchGroup(routeBase, tagHandle, ygroup, cb) {
    var key = tagHandle;
    if (cache[key]) { cb(cache[key]); return; }
    if (pending[key]) { pending[key].push(cb); return; }
    pending[key] = [cb];
    fetch(routeBase + '/collections/all/' + tagHandle + '?view=swatch-data')
      .then(function (r) { return r.json(); })
      .then(function (list) {
        // Safety net: exact tag match, in case two different tags handleize
        // to the same URL segment.
        var ps = (list || []).filter(function (p) {
          return p.tags && p.tags.indexOf(ygroup) !== -1;
        }).sort(bySwatchOrder);
        cache[key] = ps;
        pending[key].forEach(function (f) { f(ps); });
        delete pending[key];
      })
      .catch(function () {
        pending[key].forEach(function (f) { f([]); });
        delete pending[key];
      });
  }

  function switchCard(el, p) {
    var card = el.closest('product-card') || el.closest('.product-card');
    if (!card) return;
    var primary = card.querySelector('img.product-card__image--primary');
    if (primary && p.images && p.images[0]) {
      primary.removeAttribute('srcset');
      primary.removeAttribute('sizes');
      primary.src = p.images[0];
      primary.alt = p.title || '';
    }
    var secondary = card.querySelector('img.product-card__image--secondary');
    if (secondary && p.images && p.images.length) {
      secondary.removeAttribute('srcset');
      secondary.removeAttribute('sizes');
      // Fall back to the main image so the hover state never shows a stale colorway.
      secondary.src = p.images[1] || p.images[0];
    }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = p.url; });
    // Server-rendered price-list markup from the swatch-data view, so sale
    // styling / currency settings / from-pricing stay pixel-identical.
    if (p.price_html) {
      var priceEl = card.querySelector('price-list');
      if (priceEl) {
        var tmp = document.createElement('div');
        tmp.innerHTML = p.price_html;
        var newPrice = tmp.querySelector('price-list');
        if (newPrice) priceEl.replaceWith(newPrice);
      }
    }
    if (card.tagName === 'PRODUCT-CARD') card.setAttribute('handle', p.handle);
    var qb = card.querySelector('quick-buy-drawer');
    if (qb) qb.setAttribute('handle', p.handle);
    el.dataset.current = p.handle;
    el.querySelectorAll('.cc-dot').forEach(function (d) {
      d.classList.toggle('cc-dot--active', d.dataset.handle === p.handle);
    });
    // Keep the "+N" link pointed at the colorway now shown on the card.
    var more = el.querySelector('a.cc-more-count');
    if (more && p.url) more.href = p.url;
  }

  function render(el, products) {
    if (!products.length) return;
    var current = el.dataset.current;
    var row = document.createElement('div');
    row.className = 'cc-swatches__row';

    products.slice(0, SHOW_MAX).forEach(function (p) {
      var name = p.base_colour || p.color || p.title;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-dot' + (p.handle === current ? ' cc-dot--active' : '');
      btn.title = name;
      btn.setAttribute('aria-label', name);
      btn.dataset.handle = p.handle;
      btn.style.background = resolveColor(p);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        switchCard(el, p);
      });
      row.appendChild(btn);
    });

    if (products.length > SHOW_MAX) {
      // Link to the PDP of the colorway currently on the card (falls back to
      // the first product in the family if the current one isn't in the list).
      var target = null;
      for (var i = 0; i < products.length; i++) {
        if (products[i].handle === current) { target = products[i]; break; }
      }
      if (!target) target = products[0];
      var more = document.createElement('a');
      more.className = 'cc-more-count';
      more.href = target.url || ((el.dataset.routeBase || '') + '/products/' + target.handle);
      more.textContent = '+' + (products.length - SHOW_MAX);
      more.setAttribute('aria-label', 'See all ' + products.length + ' colours');
      more.title = 'See all ' + products.length + ' colours';
      row.appendChild(more);
    }

    el.appendChild(row);
  }

  function initEl(el) {
    if (el.dataset.ccDone) return;
    el.dataset.ccDone = '1';
    fetchGroup(
      el.dataset.routeBase || '',
      el.dataset.ygroupHandle,
      el.dataset.ygroup,
      function (ps) { render(el, ps); }
    );
  }

  function scan() {
    document.querySelectorAll('[data-cc-swatches]:not([data-cc-done])').forEach(initEl);
  }

  window.__ccSwatches = { scan: scan };

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Filtering/pagination re-render the grid via the Section Rendering API, which
  // injects HTML without executing script tags — watch for new swatch containers.
  if (window.MutationObserver) {
    var pendingScan = false;
    new MutationObserver(function () {
      if (pendingScan) return;
      pendingScan = true;
      setTimeout(function () { pendingScan = false; scan(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
